module.exports = __webpack_public_path__ + "static/media/people.2b09345b.svg";